import GenericSlider from "generic-slider";

if (!customElements.get("products-carousel")) {
    class ProductsCarousel extends GenericSlider {
        constructor() {
            super();
            this.filterButtons = this.querySelectorAll(
                ".products-carousel__filter--button",
            );
            this.productsGrid = this.querySelector(
                ".products-carousel__wrapper",
            );
            this.allProducts = this.productsGrid.querySelectorAll(
                ".products-carousel__slide",
            );
        }

        applyFilters(button) {
            if (!button) return;
            const filter = button.getAttribute("data-filter");
            const isCurrentlySelected = button.getAttribute("aria-selected") === "true";
            if (isCurrentlySelected) return;
            this.filterButtons.forEach((button) => {
                button.setAttribute("aria-selected", "false");
            });
            button.setAttribute("aria-selected", "true");
            this.filterProducts(filter);
        }

        filterProducts(filterTag) {
            if (this.allProducts != null) {
                this.swiper.params.allowTransition = false;
                let elementsToAdd = [];
                // set --_slider-height to current height to avoid jumpiness
                const sliderHeight =
                    this.productsGrid.getBoundingClientRect().height;
                this.slider?.style.setProperty(
                    "--_slider-height",
                    `${sliderHeight}px`,
                );
                this.swiper.removeAllSlides();
                this.allProducts.forEach((item) => {
                    const hasFilterTag = item.dataset.filterTags
                        ?.split(",")
                        .includes(filterTag);
                    if (hasFilterTag) {
                        elementsToAdd.push(item);
                    }
                });
                elementsToAdd.forEach((item) => {
                    this.swiper.appendSlide(item);
                });

                this.swiper.params.allowTransition = true;
                this.swiper.update();
                // remove --_slider-height after transition to allow auto height again
                this.slider?.style.removeProperty("--_slider-height");
            }
        }

        handleFiltersClick() {
            this.filterButtons.forEach((button) => {
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.applyFilters(button);
                });
            });
        }

        connectedCallback() {
            super.connectedCallback();
            this.handleFiltersClick();
            if (this.filterButtons.length > 0) {
                this.applyFilters(this.filterButtons[0]);
            }
        }
    }

    customElements.define("products-carousel", ProductsCarousel);
}
